import {
    OmValidationDateHelper,
    validateContactNumber,
    validatePassportNumber,
    validateSingleSelection,
} from '@om/validation';
import {
    validateAlphaNumericNotOnlyString,
    validateAlphaNumericString,
    validateAlphaString,
    validateFullName,
    validateName,
    validateNameVTwo,
    validateNumericString,
} from '@om/validation/src/validators/string-validator';
import { setQuoteDetailsFieldValid, setQuoteDetailsValue } from '../../../actions/sizotsaFuneralCover/quote';
import { validateBwIdNumber } from '@om/validation/src/validators/bw-id-number-validator';
import { getQuoteForm } from '../../../selectors/sizotsaFuneralCover/quote';
import { FIELD_STATUS } from '../../../reducers/status';
import { validateDateOfBirthVTwo } from '@om/validation/src/validators/date-of-birth-validator';
import { RELATIONS, SF_COVER_CATEGORIES } from '../../../actions/sizotsaFuneralCover/types';
import { validateEmailAddress } from '@om/validation/src/validators/email-validator';
import { validateSzIdNumber } from '@om/validation/src/validators/eswatini-id-number-validator';
import { validateDateOfBirthByWeeks, VALIDATION_VARIANT } from '@om/validation/src/validators/bw-date-of-birth-validator';

export const quoteDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const trimValue = (value) => (value ? value.trim() : value);
        const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
        const {
            selectedCoverCategory,
            childHaveSpecialNeed,
            childIsStudent,
            email,
            cellphone,
            title,
            nationality,
            hearAboutUs,
            dateOfBirth,
            referFriendFamily,
        } = getQuoteForm(store.getState());

        const calculateAge = (dob) => {
  // Parse DD/MM/YYYY
  const [day, month, year] = dob.split("/").map(Number);
  const dobDate = new Date(year, month - 1, day);

  const now = new Date();

  if (isNaN(dobDate.getTime()) || dobDate > now) {
    return 0; // invalid or future date
  }

  let years = now.getFullYear() - dobDate.getFullYear();
  let months = now.getMonth() - (month - 1);
  let days = now.getDate() - day;

  // Adjust for incomplete month
  if (days < 0) {
    months -= 1;
  }

  // Total months difference
  let totalMonths = years * 12 + months;
  if (totalMonths < 0) return 0; // future date guard

//   // If less than 1 year → return months in decimal form
//   if (totalMonths < 12) {
//     return +(totalMonths / 12).toFixed(1); // one decimal place
//   }

  // Otherwise return whole years
  return Math.ceil(+(totalMonths / 12).toFixed(1));
};
// console.log(age);

        const getChildsMaxAgeCriteria = () => {
            if (childHaveSpecialNeed.value === 'Yes') {
                return 200; // 200 years
            } else if (childIsStudent.value === 'Yes') {
                return 24 ; // 24 years
            }
            return 20; // 20 years
        };
        const ageCiteria = {
            [SF_COVER_CATEGORIES.MYSELF]: 59,
            [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: 59,
            [SF_COVER_CATEGORIES.BENEFECIARY]: 119,
        };

        const platforms = ['omEmployee', 'broker',];
        let error;
        switch (action.value.fieldType) {
            case 'dateOfBirth':
                error = [SF_COVER_CATEGORIES.EXTENDED_FAMILY, RELATIONS.CHILD].includes(selectedCoverCategory.value)
                    ? validateDateOfBirthByWeeks(action.value.value, selectedCoverCategory.value==='Child'?{
                          min: 26,
                          max: 119,
                          maxVariant: VALIDATION_VARIANT.YEARLY,
                          subject: 'Date of birth',
                          pronoun: ' ',
                      }:{   min: 1,
                        max: 69,
                        subject: 'Date of birth',
                        minVariant:VALIDATION_VARIANT.MONTHLY,
                        maxVariant:VALIDATION_VARIANT.YEARLY,
                        pronoun: ' ',
                    })
                    : validateDateOfBirthVTwo(action.value.value, {
                          min:18,
                          max: ageCiteria[selectedCoverCategory.value] ?? 69,
                          subject: 'Date of birth',
                          pronoun: ' ',
                      });
                error ??
                    store.dispatch(
                        setQuoteDetailsValue({
                            fieldType: 'age',
                            value: calculateAge(action.value.value),
                            displayValue: null,
                        })
                    );
                break;
            case 'gender':
                error = validateSingleSelection(action.value.value, 'Gender');
                break;
            // case 'childDateOfBirth':
            //     error = validateDateOfBirth(action.value.value, {
            //         min: 1,
            //         max: 21,
            //         subject: 'Date of birth',
            //     });
            //     error ?? store.dispatch(setQuoteDetailsValue({ fieldType:'age', value:calculateAge(action.value.value), displayValue:null }));
            //     break;
            case 'relationship':
                error = validateSingleSelection(action.value.value, 'RelationShip');
                break;
            case 'selectedCoverCategory':
                error = validateSingleSelection(action.value.value, 'Cover');
                break;
            case 'benefitsDetails':
                error = validateSingleSelection(action.value.value, 'Cashback option');
                break;
            case 'benefitsDetailsOnPremium':
                error = validateSingleSelection(action.value.value, 'Premium paid up');
                break;
            case 'title':
                error = validateSingleSelection(action.value.value, 'Title');
                break;
            case 'nationality':
                error = validateSingleSelection(action.value.value, 'Nationality');
                break;
            case 'needIncomeStabilization':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'hearAboutUs':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'hearAboutUsPlatform':
                error = action?.value?.value ? (platforms.includes(hearAboutUs?.displayValue)
                    ? validateFullName(trimValue(action.value.value), {
                          min: 3,
                          max: 66,
                          subject: 'Full name of referrer',
                          required: false,
                      })
                    : validateAlphaNumericString(action.value.value, {
                          max: 3,
                          min: 66,
                          subject: 'Text field',
                          required: false,
                      })): null;
                break;

            case 'socialPlatform':
                error = validateSingleSelection(action.value.value, 'an option');
                break;
            case 'referFriendFamily':
                error = validateSingleSelection(action.value.value, 'an option');
                break;
            case 'referFullName':
                error = validateFullName(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Full name',
                });
                break;
            case 'referCellphoneNumber':
                error = validateContactNumber(action.value.value, {
                    countryCode: 'bw',
                    leadingZeroValidation: false,
                    required: referFriendFamily?.value === 'No' ? false : true,
                });
                break;

            case 'childHaveSpecialNeed':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'childIsStudent':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'email':
                error = validateEmailAddress(action.value.value, {
                    min: 10,
                    max: 60,
                    subject: 'Email address',
                    required: false,
                    // required: !cellphone.value,
                });
                break;
            case 'cellphone':
                error = validateContactNumber(action.value.value, {
                    countryCode: 'sz',
                    leadingZeroValidation: false,
                    required: true,
                    subject:'Eswatini contact number'
                    // required: !email.value,
                });
                break;
            case 'id':
                if (nationality?.value === 'Eswatini') {
                    error = validateSzIdNumber(action.value.value, {
                        required: selectedCoverCategory.value === SF_COVER_CATEGORIES.BENEFECIARY,
                        subject: 'Eswatini Id',
                        gender: title?.value === 'Mr.' ? 'Male' : 'Female',
                        dateOfBirth: dateOfBirth?.value,
                    });
                    break;
                }
                error = validatePassportNumber(action.value.value, {
                    required: selectedCoverCategory.value === SF_COVER_CATEGORIES.BENEFECIARY,
                    subject: 'Passport Id',
                });
                break;

            case 'firstName':
                error = validateNameVTwo(action.value.value, { subject: 'First name', min: 3, max: 66 });
                break;

            case 'surname':
                error = validateNameVTwo(action.value.value, { subject: 'Surname', min: 3, max: 66 });
                break;

            case 'memberFromLivesCovered':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'beneficiaryName':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'agentDetail':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            
            case 'currentResidence':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'agentCode':
                error = validateAlphaNumericNotOnlyString(action.value.value, {
                    min: 1,
                    required: true,
                    subject: 'agent code',
                });
                break;
            // case 'coverAmount':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break

            // case 'monthlyPremium':
            //    break
            // case 'addPartner':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break
            // case 'addChild':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break;

            default:
                return null;
        }

        return setQuoteDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    return next(action);
};
